import React from 'react'
import classNames from 'classnames'

type BadgeVariant =
  | 'default'
  | 'secondary'
  | 'destructive'
  | 'outline'
  | 'success'
  | 'warning'
  | 'info'

interface BadgeProps {
  as?: React.ElementType
  variant?: BadgeVariant
  className?: string
  children: React.ReactNode
}

const Badge = React.forwardRef<HTMLElement, BadgeProps>(
  ({ as: Component = 'div', variant = 'default', className = '', children, ...props }, ref) => {
    const baseClasses = 'badge rounded-pill fs-4 border'

    const variantClasses = {
      default: 'bg-primary text-white border-primary',
      secondary: 'bg-secondary text-white',
      destructive: 'bg-danger text-white',
      outline: 'bg-transparent text-primary border-primary',
      success: 'bg-success text-white',
      warning: 'bg-warning text-dark',
      info: 'bg-info text-white',
    }

    const classes = classNames(baseClasses, variantClasses[variant], className)

    return (
      <Component
        ref={ref}
        className={classes}
        style={{
          padding: '0.15rem 0.5rem',
          lineHeight: 1.5,
        }}
        {...props}
      >
        {children}
      </Component>
    )
  }
)

Badge.displayName = 'Badge'

export { Badge }
